.banner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0.02em;
}

.message {
  flex-shrink: 0;
}

.error {
  background: var(--red-10);
  color: var(--red-90);
}

.warning {
  background: var(--yellow-20);
  color: var(--yellow-90);
}
